const axios = require('axios');
const validate = require("validate.js");

export default () => ({

    errors: {},

    loginResponseError: null,

    validationConstraints: {
        email: {
            presence: {
                allowEmpty: false,
                message: "^ Wat is je E-mailadres?"
            },
            email: true
        },
        terms: {
            presence: {
                message: "^Ga je akkoord met onze voorwaarden?"
            },
            inclusion: {
                within: [true],
                message: "^Ga je akkoord met onze voorwaarden?"
            }
        }
    },

    open: false,

    displayLogin: false,
    displayEmailOnly: false,
    displayCheckout: false,
    displayCheckYourEmail: false,
    emailExistsError: false,

    redirectBase: "/checkout/create?subscriptionItem=",
    subscriptionId: null,
    redirectUrl: null,
    checkoutUrl: null,

    loginName: null,
    loginPassword: null,
    email: null,
    acceptedTerms: false,
    acceptsNewsletters: false,

    displayLoginOption(){

        this.displayEmailOnly = false;
        this.displayLogin = true;
        this.displayCheckYourEmail = false;
        this.displayCheckout = false;
    },

    displayEmailOnlyOption(){

        this.displayLogin = false;
        this.displayEmailOnly = true;
        this.displayCheckYourEmail = false;
        this.displayCheckout = false;
    },

    initializeDonationLoginOptions(subscriptionId){
        this.subscriptionId = subscriptionId;

        this.redirectUrl = this.redirectBase + this.subscriptionId;

        this.open = true;
    },

    closeLoginOptions()
    {
        this.displayLogin = false;
        this.displayEmailOnly = false;
    },

    handleLoginFormSubmit()
    {
        let csrfTokenName = document.querySelector('meta[name="csrf-token-name"]').content;
        let csrfTokenValue = document.querySelector('meta[name="csrf-token"]').content;

        let formData = new FormData(this.$refs.loginForm);
        formData.set(csrfTokenName, csrfTokenValue);

        // validate login form?

        axios.post('', formData)
             .then((response) => {

                 if(!response.data.error)
                 {
                     window.location.href = this.redirectUrl;
                 }

                this.loginResponseError = response.data.error;

             }).catch(function (error) {

                alert('something went wrong whilst trying to submit the form');

             });

    },

    validate(){

        var formData = new FormData(this.$refs.emailOnlyForm);

        var attributes = {
            email: formData.get('email'),
            terms: (formData.get('fields[acceptedTerms]')) ? true : false
        };

        let errors = validate(attributes, this.validationConstraints);

        this.errors = (errors) ? errors : {};

        if(!errors) {
            return true;
        }

        return false;
    },

    handleEmailOnlySubmit(e){

        if(this.validate()){

            let csrfTokenName = document.querySelector('meta[name="csrf-token-name"]').content;
            let csrfTokenValue = document.querySelector('meta[name="csrf-token"]').content;

            let formData = new FormData(this.$refs.emailOnlyForm);
            formData.set(csrfTokenName, csrfTokenValue);

            axios.post('', formData)
                .then((response) => {

                    if(response.data.url != undefined)
                    {
                        this.checkoutUrl = response.data.url;
                        this.displayEmailOnly = false;
                        this.displayCheckout = true;
                    }

                    if(response.data.check_email)
                    {
                        this.displayEmailOnly = false;
                        this.displayCheckYourEmail = true;
                    }

                    if (response.data.email_exists) {
                        this.emailExistsError = true;
                    }

                }).catch(function (error) {

                alert('something went wrong whilst trying to submit the form');

            });
        }
    },

    closeModal(){

        this.open = false;

        this.redirectUrl = null;
        this.checkoutUrl = null;
        this.subscriptionId = null;

        this.errors = {}
        this.loginResponseError = null;

        this.loginName = null;
        this.loginPassword = null;

        this.email = null;
        this.acceptedTerms = false;
        this.acceptsNewsletters = false;

        this.displayLogin = false;
        this.displayEmailOnly = false;
        this.displayCheckout = false;
        this.displayCheckYourEmail = false;
    }

});
